__webpack_require__.p = "https://bmidxbfinlandplpreprod.netlify.app/";